import { render, staticRenderFns } from "./comment-item.vue?vue&type=template&id=3dfc2e86&scoped=true&"
import script from "./comment-item.vue?vue&type=script&lang=js&"
export * from "./comment-item.vue?vue&type=script&lang=js&"
import style0 from "./comment-item.vue?vue&type=style&index=0&id=3dfc2e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc2e86",
  null
  
)

export default component.exports